import { render, staticRenderFns } from "./VolumeTransaction.vue?vue&type=template&id=6d26b22e&"
import script from "./VolumeTransaction.vue?vue&type=script&lang=js&"
export * from "./VolumeTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports